import { render, staticRenderFns } from "./viewCurrencyExchange.vue?vue&type=template&id=47ed4407&scoped=true"
import script from "./viewCurrencyExchange.vue?vue&type=script&lang=js"
export * from "./viewCurrencyExchange.vue?vue&type=script&lang=js"
import style0 from "./viewCurrencyExchange.vue?vue&type=style&index=0&id=47ed4407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed4407",
  null
  
)

export default component.exports